'use client';

import React, {Fragment, useEffect, useState} from 'react';
import {usePathname} from "next/navigation";
import Link from "next/link";
import {Disclosure, Popover, Transition} from "@headlessui/react";
import {
    HiBars3,
    HiChevronDown,
    HiSquaresPlus, HiXMark
} from "react-icons/hi2";
import ButtonSwitchTheme from "@/components/ui/buttons/switch-theme/ButtonSwitchTheme";
import ElevatedLinkButton from "@/components/ui/buttons/global/ElevatedLinkButton";
import ButtonAppLogo from "@/components/ui/buttons/logo/ButtonAppLogo";

const products = () => [
    {
        name: 'بازی نقطه خط',
        description: "بازی کلاسیک که روی یک کاغذ چندین نقطه قرار میدهند که افراد به نوبت خود بین نقطه ها خط میکشند",
        href: "/games/dots-boxes",
        icon: HiSquaresPlus,
    }
];

const MainHeader = () => {

    const pathName = usePathname();

    // const {session} = useSessionContext();
    // const {lang} = useLangContext();

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        setMobileMenuOpen(false);
    }, [pathName]);

    // let's make a function that receive the specific element_id as string and scroll into that element_id
    const scrollToHash = function (element_id: string) {
        const element = document.getElementById(element_id)
        element?.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        setMobileMenuOpen(false)
    }

    return (
        <header className={`backdrop-blur bg-white/80 dark:bg-stone-950/80 sticky top-0 z-50 `}>
            <div>
                <nav className={'mx-auto flex max-w-7xl items-center justify-between p-3 lg:px-8'}
                     aria-label="Global">
                    <div className="flex md:flex-1">
                        <Link
                            href={`/`}
                            className="-m-1.5 p-1.5 flex items-center "
                        >
                            <ButtonAppLogo height={30} width={30}/>
                        </Link>
                    </div>

                    <div className="flex md:hidden">
                        <button
                            type="button"
                            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-stone-700 dark:text-stone-200"
                            onClick={() => setMobileMenuOpen(prevState => !prevState)}
                        >
                            <span className="sr-only">Open main menu</span>
                            <HiBars3 className="h-6 w-6" aria-hidden="true"/>
                        </button>
                    </div>

                    <Popover.Group
                        className="hidden md:flex md:gap-x-12"
                    >
                        <Popover className="relative">
                            <Popover.Button
                                className="flex items-center gap-x-1 text-sm font-semibold leading-6 text-stone-950 dark:text-stone-50">
                                {'محصولات'}
                                <HiChevronDown
                                    className="h-5 w-5 flex-none text-stone-400 "
                                    aria-hidden="true"
                                />
                            </Popover.Button>

                            <Transition
                                as={Fragment}
                                enter="transition ease-out duration-200"
                                enterFrom="opacity-0 translate-y-1"
                                enterTo="opacity-100 translate-y-0"
                                leave="transition ease-in duration-150"
                                leaveFrom="opacity-100 translate-y-0"
                                leaveTo="opacity-0 translate-y-1"
                            >
                                <Popover.Panel
                                    className="absolute -start-8 top-full z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white dark:bg-stone-700 shadow-lg ring-1 ring-black dark:ring-stone-600 ring-opacity-5"
                                >
                                    <div className="p-3">
                                        {products().map((item) => (
                                            <div
                                                key={item.name}
                                                className="group  relative flex items-center gap-x-4 rounded-xl p-3 text-sm leading-4 hover:bg-stone-100 dark:hover:bg-stone-800 transition-colors duration-300"
                                            >
                                                <div
                                                    className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-stone-200 dark:bg-stone-950 group-hover:bg-stone-300 dark:group-hover:bg-stone-950">
                                                    <item.icon
                                                        className="h-6 w-6 text-stone-800 dark:text-stone-200 group-hover:text-stone-600 dark:group-hover:text-stone-400"
                                                        aria-hidden="true"
                                                    />
                                                </div>
                                                <div className="flex-auto">
                                                    <button
                                                        // href={item.href}
                                                        onClick={event => {
                                                            event.preventDefault();
                                                            scrollToHash(item.href)
                                                        }}
                                                        className="block font-semibold text-stone-950 dark:text-stone-50"
                                                    >
                                                        {item.name}
                                                        <span className="absolute inset-0"/>
                                                    </button>
                                                    <p className="mt-1 text-stone-600 dark:text-stone-400">{item.description}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {/*<div*/}
                                    {/*    className="grid grid-cols-2 divide-x divide-stone-950/5 bg-stone-50 dark:bg-stone-950"*/}
                                    {/*>*/}
                                    {/*    {callsToAction().map((item) => (*/}
                                    {/*        <a*/}
                                    {/*            key={item.name}*/}
                                    {/*            href={`/${item.href}`}*/}
                                    {/*            className="flex items-center justify-center gap-x-2.5 p-3 text-sm font-semibold leading-6 text-stone-950 dark:text-stone-100 hover:bg-stone-100 dark:hover:bg-stone-950"*/}
                                    {/*        >*/}
                                    {/*            <item.icon*/}
                                    {/*                className="h-5 w-5 flex-none text-stone-500"*/}
                                    {/*                aria-hidden="true"*/}
                                    {/*            />*/}
                                    {/*            {item.name}*/}
                                    {/*        </a>*/}
                                    {/*    ))}*/}
                                    {/*</div>*/}
                                </Popover.Panel>
                            </Transition>
                        </Popover>

                        <Link
                            href={`/github`}
                            className="text-sm font-semibold leading-6 text-stone-950 dark:text-stone-50"
                        >
                            {"گیتهاب"}
                        </Link>
                        <a
                            href="#"
                            className="text-sm font-semibold leading-6 text-stone-950 dark:text-stone-50"
                        >
                            {"وبلاگ"}
                        </a>
                        <button
                            // href={'#aboutUs'}
                            onClick={(e) => {
                                e.preventDefault();
                                scrollToHash('aboutUs');
                            }}
                            className="text-sm font-semibold leading-6 text-stone-950 dark:text-stone-50"
                        >
                            {"درباره ما"}
                        </button>
                    </Popover.Group>

                    <div className="hidden md:flex md:flex-1 items-center md:justify-end">
                        <ButtonSwitchTheme />
                        <ElevatedLinkButton
                            bgColor={'bg-green-400'}
                            hover={'hover:bg-green-600'}
                            rounded={'rounded-xl hover:rounded-3xl'}
                            href={`/signIn`}
                        >
                            {'ورود'}
                        </ElevatedLinkButton>
                    </div>

                </nav>
            </div>
            <div>
                <aside
                    id="logo-sidebar"
                    className={`fixed top-0 start-0 z-40 sm:w-96 w-full transition-all h-screen ${
                        mobileMenuOpen ? "translate-x-0" : 'translate-x-full'
                    } bg-white border-r border-stone-200 dark:bg-stone-900 dark:border-stone-700`}
                    aria-label="Sidebar"
                >
                    <div className="h-full px-3 py-6 overflow-y-auto">
                        <div className="flex items-center justify-between">
                            <div className={'flex-grow'}>
                                <Link href={`/`} className="-m-1.5 p-1.5 flex items-center">
                                    <span className="sr-only">NasrPay Logo</span>
                                    <ButtonAppLogo height={28} width={28}/>
                                </Link>
                            </div>
                            <ButtonSwitchTheme className="ms-auto"/>
                            <button
                                type="button"
                                className="-ms-3 rounded-md p-2.5 text-stone-700 dark:text-stone-300"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                <span className="sr-only">Close menu</span>
                                <HiXMark className="h-6 w-6" aria-hidden="true"/>
                            </button>
                        </div>
                        <div className="mt-6 mx-3 flow-root">
                            <div className="-my-6 divide-y divide-stone-500/10">
                                <div className="space-y-2 py-6">
                                    <Disclosure as="div" className="-mx-3">
                                        {({open}) => (
                                            <div>
                                                <Disclosure.Button
                                                    className="flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base font-semibold leading-7 text-stone-950 dark:text-stone-100 hover:bg-stone-50 dark:hover:bg-stone-950">
                                                    {"محصولات"}
                                                    <HiChevronDown
                                                        className={`${
                                                            open ? "rotate-180" : ""
                                                        } h-5 w-5 flex-none`}
                                                        aria-hidden="true"
                                                    />
                                                </Disclosure.Button>
                                                <Disclosure.Panel className="mt-2 space-y-2">
                                                    {[
                                                        ...products(),
                                                        // ...callsToAction(),
                                                    ].map((item) => (
                                                        <Disclosure.Button
                                                            key={item.name}
                                                            as="button"
                                                            // href={item.href}
                                                            onClick={event => {
                                                                event.preventDefault();
                                                                scrollToHash(item.href);
                                                            }}
                                                            className="block rounded-lg w-full text-start py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-stone-950 dark:text-stone-100 hover:bg-stone-50 dark:hover:bg-stone-950"
                                                        >
                                                            {item.name}
                                                        </Disclosure.Button>
                                                    ))}
                                                </Disclosure.Panel>
                                            </div>
                                        )}
                                    </Disclosure>
                                    <Link
                                        href={`/github`}
                                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-stone-950 dark:text-stone-100 hover:bg-stone-50 dark:hover:bg-stone-950"
                                    >
                                        {"گیتهاب"}
                                    </Link>
                                    <a
                                        href="#"
                                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-stone-950 dark:text-stone-100 hover:bg-stone-50 dark:hover:bg-stone-950"
                                    >
                                        {"وبلاگ"}
                                    </a>
                                    <a
                                        onClick={event => {
                                            event.preventDefault();
                                            scrollToHash('aboutUs');
                                        }}
                                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-stone-950 dark:text-stone-100 hover:bg-stone-50 dark:hover:bg-stone-950"
                                    >
                                        {"درباره ما"}
                                    </a>
                                </div>
                                <div className="py-6 flex items-center gap-x-3">
                                    <ElevatedLinkButton
                                        href={`/signIn`}
                                        bgColor={'bg-green-400'}
                                        hover={'hover:bg-green-600 hover:rounded-xl'}
                                    >
                                        {"ورود"}
                                    </ElevatedLinkButton>
                                </div>
                            </div>
                        </div>

                    </div>
                </aside>
            </div>
        </header>
    );
};

export default MainHeader;
